import React, { Component } from 'react';
import { reduxForm, formValueSelector } from 'redux-form';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { formatMessage } from '../../lib/intl';

import InviteFields from './invite-fields';
import RightSidebar from './right-sidebar';
import FormFooter from '../form-footer';
import validate from './validate';
import '../../css/invitees.css';

const i18n = defineMessages({
  defaultSubject: {
    id: 'invitePeople.defaultSubject',
    defaultMessage: 'Split the cost of {purchaseName}',
  },
});

export class InvitePeople extends Component {
  constructor(props) {
    super(props);
    const { purchaseName } = props;
    this.formatMessage = formatMessage(this.props.intl);
    this.state = {
      subject: this.formatMessage(i18n.defaultSubject, {purchaseName}),
      message: null,
      invalidEmails: [],
    };
  }

  onMessageChange = (message) => {
    this.setState({ message });
  }

  onSubjectChange = (subject) => {
    this.setState({ subject });
  }

  onEmailsInvalid = (invalidEmails) => {
    this.setState({
      invalidEmails,
    });
  }

  renderEmailErrors() {
    if (!this.state.invalidEmails.length) {
      return null;
    }

    return (
      <p className="text-right error">
        <FormattedMessage
          id="invitePeople.invalidEmails"
          defaultMessage="Some emails you entered have errors. Check the 'Email(s)’
            field to correct them."
        />
      </p>
    )
  }

  render() {
    const { innerAlert, handleSubmit, submitting } = this.props;

    return (
      <form className="invite-people" onSubmit={handleSubmit(this.props.onSubmit)}>
        <div className="invites-form row">
          <div className="main">
            {innerAlert}
            <h2>
              <FormattedMessage
                id="invitePeople.title"
                defaultMessage="Compose Invites"
              />
            </h2>
            <InviteFields
              onContactsImported={this.onContactsImported}
              showImportOptions={this.props.showImportOptions}

              onSubjectChange={this.onSubjectChange}
              onMessageChange={this.onMessageChange}
              onEmailsInvalid={this.onEmailsInvalid}
            />

            <FormFooter />

            <div className="row">
              <div className="col-7">
                {this.renderEmailErrors()}
              </div>
              <div className="col-5">
                <button type="submit" className="btn btn-primary submit" disabled={submitting}>
                  <FormattedMessage
                    id="invitePeople.submit"
                    defaultMessage="Send Invites"
                  />
                </button>
              </div>
            </div>
          </div>
          <div className="sidebar">
            <RightSidebar
              merchant={this.props.merchant}
              subject={this.state.subject}
              message={this.state.message}
            />
          </div>
        </div>
      </form>
    );
  }
}
const FORM_NAME = 'invitesForm';
export const formSelector = formValueSelector(FORM_NAME);
export default injectIntl(reduxForm({ form: FORM_NAME, validate })(InvitePeople));



// WEBPACK FOOTER //
// ./src/desktop/components/invite-people/index.js